import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import moment from "moment";
// Antd
import { Typography, Row, Col, Icon, Collapse, Tabs } from "antd";

// Formik
import { FastField, Formik } from "formik";

// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../components/Buttons";
import Input from "../../../../components/Common/Input";
import typo, { MESSAGE } from "../../../../constants/dictionaries";
import Select from "../../../../components/Common/Select";
import message from "../../../../components/Messages";
import DateField from "../../../../components/Common/DateField"
import ValidatedText from "../../../../components/Common/ValidatedText";
import DoanhNghiepGroup from "../../../../components/BaoCao/DNXCP";
import TextArea from "../../../../components/Common/TextArea";
import FileDinhKemPlus from "../../../../components/ThongTinTNN/FileDinhKem/TablePlus"
import Table from "../../../../components/Table";
import NumberField from "../../../../components/Common/NumberField";
// Colors
import colors from "../../../../constants/colors";

// Styled components
import styles from "./Modal.module.scss";
import Api_tnn from "../../../../api/api.tnn";
import Helper from "../../../../helper/helper";
import Box from "../../../../components/Box";
import Api from "../../../../api";
import KetQuaQuanTrac from "../../../../components/BaoCaoDinhKy/KetQuaQuanTracQDXP/Table";
import Constant from "../../../../constants/constant";
import Api_quantrac from "../../../../api/api.quantrac";
import DisplayFormikState from '../../../../components/Table/DisplayFormikState'
import Du_An from "../../../../components/BaoCao/Du_An";
const { Text } = Typography;
const { TabPane } = Tabs;
const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerFile = styled.div`
  padding-top: 30px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const dateFormat = 'DD/MM/YYYY';
// Validations for add user
const addOrEditSchema = Yup.object().shape({
  doanhNghiep_Id: Yup.string().required(typo.cscore_input_Required),
  soQD: Yup.string().required(typo.cscore_input_Required),
  ngayBD_HieuLuc: Yup.string().required(typo.cscore_input_Required),
  ngayKy: Yup.string().required(typo.cscore_input_Required),
  coQuanCap: Yup.string().required(typo.cscore_input_Required),
});

class BCDKModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      dataDiemXaThai: [],
      thietLapMau: [],
      loaiGP: undefined,
      years: [],
      KQQT: [],
      fileList: this.props.selectedRow ? this.props.selectedRow.files : undefined,
      thietlapmau: [
        {
          tpmt_ma: 0,
          kqqt: ""
        }
      ],
    };
  }

  componentDidMount() {
    const { isEdit, selectedRow } = this.props
    this.getYears()
    if (isEdit) {
      this.setState({
        initialValues: selectedRow,
        KQQT: selectedRow.kqqT_LIST ? JSON.parse(selectedRow.kqqT_LIST) : []
      })
    }
  }
  getYears = () => {
    var c_year = new Date().getFullYear(); var years = []
    for (var i = c_year + 20; i >= 1975; i--) { years.push({ year: i }) }
    this.setState({ years: years })
  }
  updateFileDinhKems = (items) => {
    this.setState({
      fileList: items
    })
  }

  handleUpdateKQQT = (item) => {
    this.setState({
      KQQT: item.map((e,idx) => ({...e, stt: idx + 1}))
    })
  }

  thietlap = (value) => {
    const { thietlapmau } = this.state
    let objdatas = thietlapmau.filter(x => x.tpmt_ma === value.tpmt_ma);
    if (objdatas.length === 0) {
      thietlapmau.push(value)
    } else {
      thietlapmau.map((item, index) => {
        if (item.tpmt_ma === value.tpmt_ma) {
          thietlapmau.splice(index, 1)
        }
      })
      thietlapmau.push(value)
    }
    message.success(MESSAGE.CSCORE_THIET_LAP_MAU);
  }

  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd,
      user
    } = this.props;
    const { initialValues, years, fileList, KQQT, thietlapmau } = this.state
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={(values, actions) => {
            if (isEdit) {
              new Api_quantrac()
                .PutTT_QDXP({
                  token: this.props.user.access_token,
                  objQD: {
                    ...values,
                    files: fileList,
                    kqqT_LIST: JSON.stringify(KQQT),
                  },
                  id: selectedRow.id
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
            else {
              new Api_quantrac()
                .PostTT_QDXP({
                  token: this.props.user.access_token,
                  objQD: {
                    ...values,
                    files: fileList,
                    kqqT_LIST: JSON.stringify(KQQT),
                  },
                })
                .then(res => {
                  message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                  handleAdd();
                  actions.resetForm({});
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
              <form onSubmit={handleSubmit} autoComplete="false">
                <ControllerForm>
                  <Tabs type="card">
                    <TabPane tab={typo.cscore_common_info} key="1" forceRender={true}>

                      <Row>
                        <Col span={12}>
                          <ControllerInput>
                            <DoanhNghiepGroup
                              values={values}
                              setFieldValue={setFieldValue}
                              mode={isEdit ? "edit" : "add"}
                              handleGP={() => { }}
                            />

                            <FastField name="tenVanBan" render={({ field }) => (
                              <Input placeholder={typo.cscore_license_document} label={typo.cscore_license_document} mandatory={false} {...field} />)} />

                            <FastField name="soQD" render={({ field }) => (
                              <Input placeholder={typo.cscore_soQuyetDinh} label={typo.cscore_soQuyetDinh} {...field} />)} />
                            {touched.soQD && <ValidatedText type="danger">{errors.soQD}</ValidatedText>}

                            <DateField
                              format={dateFormat}
                              placeholder={Helper.genSelectPL(typo.cscore_ngayquyetdinh)}
                              label={typo.cscore_ngayquyetdinh}
                              onChange={value => { setFieldValue("ngayKy", value && value.format()) }}
                              defaultValue={values.ngayKy}
                              value={values.ngayKy ? moment(values.ngayKy) : null}
                            />

                            <DateField
                              format={dateFormat}
                              placeholder={Helper.genSelectPL(typo.cscore_ngay_hieu_luc)}
                              label={typo.cscore_ngay_hieu_luc}
                              onChange={value => { setFieldValue("ngayBD_HieuLuc", value && value.format()) }}
                              defaultValue={values.ngayBD_HieuLuc}
                              value={values.ngayBD_HieuLuc ? moment(values.ngayBD_HieuLuc) : null}
                            />

                            <FastField name="nguoiKy" render={({ field }) => (
                              <Input placeholder={typo.cscore_license_signed_person} label={typo.cscore_license_signed_person} mandatory={false} {...field} />)} />
                            {touched.nguoiKy && <ValidatedText type="danger">{errors.nguoiKy}</ValidatedText>}

                            <FastField name="chucVu" render={({ field }) => (
                              <Input placeholder={typo.cscore_input_CV} label={typo.cscore_input_CV} mandatory={false} {...field} />)} />
                            {touched.chucVu && <ValidatedText type="danger">{errors.chucVu}</ValidatedText>}

                          </ControllerInput>
                        </Col>
                        <Col span={12}>
                          <ControllerInput>
                            <FastField name="coQuanCap" render={({ field }) => (
                              <Input placeholder={typo.cscore_coquanraquyetdinh} label={typo.cscore_coquanraquyetdinh} {...field} />)} />

                            <Du_An
                              values={values}
                              setFieldValue={setFieldValue}
                              mode={isEdit ? "edit" : "add"}
                              handleGP={() => { }}
                            />

                            <NumberField
                              label={typo.cscore_tongtienphat}
                              placeholder={typo.cscore_tongtienphat}
                              id="tongTienPhat"
                              min={0}
                              onChange={value => setFieldValue("tongTienPhat", value)}
                              value={values.tongTienPhat}
                              mandatory={false}
                            />
                            <FastField
                              name="noiDung_ViPham"
                              render={({ field }) => <TextArea placeholder={typo.cscore_noidungvipham} label={typo.cscore_noidungvipham} mandatory={false} {...field} rows={2} />}
                            />

                            <FastField
                              name="noiDung_KhacPhuc"
                              render={({ field }) => <TextArea placeholder={typo.cscore_noidungkhacphuc} label={typo.cscore_noidungkhacphuc} mandatory={false} {...field} rows={2} />}
                            />

                            <FastField
                              name="ghiChu"
                              render={({ field }) => <TextArea placeholder={typo.cscore_note} label={typo.cscore_note} mandatory={false} {...field} rows={2} />}
                            />
                          </ControllerInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <ControllerFile>
                            <Box label={typo.cscore_fileDinhkem}>
                              <FileDinhKemPlus dataSource={fileList} updateDataSource={this.updateFileDinhKems} />
                            </Box>
                          </ControllerFile>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tab={typo.cscore_ket_qua_QT} key="2">
                      <Box size="small">
                        <KetQuaQuanTrac dataSource={KQQT} handleUpdate={this.handleUpdateKQQT} idQuyetDinh={isEdit ? values.id : 0} thietlap={this.thietlap} thietlapmau={thietlapmau} />
                      </Box>
                    </TabPane>

                  </Tabs>
                  <ControllerButton>
                    <button
                      className='ant-btn'
                      type="submit"
                    >
                      <Icon type="save" style={{ marginRight: "8px" }} />
                      {typo.cscore_submit}
                    </button>
                    <Button
                      type="cancel"
                      className={styles.buttonMargin}
                      onClick={handleCloseModal}
                    >
                      <Icon type="arrow-right" />
                      {typo.cscore_exit}
                    </Button>
                  </ControllerButton>
                </ControllerForm>
                {/* <DisplayFormikState values={values} errors={errors}/> */}
              </form>
            )}
        />
      </div>
    );
  }
}

BCDKModal.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default BCDKModal;
